import React, { createContext, useContext, useState, useEffect } from 'react';
import { verifyToken, logout as apiLogout } from '../api/api';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // On mount, check if we have a valid session via HttpOnly cookie.
    // The browser sends the cookie automatically — JS never touches the token.
    verifyToken()
      .then(data => {
        setUser({ username: data.username });
      })
      .catch(() => {
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const loginUser = (username) => {
    // Cookie is already set by the backend; we just store the username in state
    setUser({ username });
  };

  const logoutUser = async () => {
    try {
      await apiLogout(); // Tells the backend to clear the HttpOnly cookie
    } catch {
      // Best effort — clear local state regardless
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginUser, logoutUser }}>
      {children}
    </AuthContext.Provider>
  );
};
